import { connect } from 'react-redux';
import { RouteComponentProps } from '../../../../../../shared/common/types/common';
import { safeParseInt } from '../../../../../../shared/common/utils';
import { TError } from '../../../../../../shared/frontend/scripts/actions/errorActions';
import { TKeystoneTeamRankingsClientState } from '../../libs/store';
import { findBySlug } from '../../../../../../shared/frontend/libs/utils';
import { actions, getEmptyTeamLeaderboardState, TActions } from '../modules';

/* tslint:disable:max-line-length */

type TPropsFromState = any; // FIXME: type this!

type TPropsThatDispatch = {
  setKeystoneTeamRankings(actionData: TKeystoneTeamRankingsClientState): void;
  showError(actionData: TError): void;
  showLoadingSpinner(show: boolean): void;
};

type TKeystoneTeamRankingsProps = TPropsFromState & TPropsThatDispatch & RouteComponentProps<any, any>;

// take state from store and convert into props
function mapStateToProps(state: any, ownProps: any): TPropsFromState {
  const weekId = safeParseInt(ownProps.week, 0);
  const periodsForCurrentSeason = findBySlug(state.siteMeta.seasons, ownProps.season);

  return {
    ...getEmptyTeamLeaderboardState(),
    ...state.team.viewTeamLeaderboard[ownProps.instanceId || 'default'],
    dungeons: state.siteMeta.dungeons,
    regions: state.siteMeta.regions,
    // FIXME: hack on checking 'US ' prefix is that we do not want timezones in the list
    subRegions: state.siteMeta.subRegions
      .filter((sr: any) => sr.name.indexOf('US ') !== 0 && sr.regions.length === 1 && sr.name !== 'Americas')
      .sort((a: any, b: any) => a.name.localeCompare(b.name)),
    siteConfig: state.siteConfig,
    siteMeta: state.siteMeta,
    periodsForCurrentSeason: findBySlug(state.siteMeta.seasons, ownProps.season),
    currentPeriod:
      ownProps.week !== 'all'
        ? periodsForCurrentSeason.periods.find((periodInfo: any) => periodInfo.week === weekId)
        : null
  };
}

// return one entire set of props
function mergeProps(stateProps: TPropsFromState, dispatchProps: TActions, ownProps: any) {
  let eventId = 1;
  if (ownProps.event) {
    eventId = ownProps.event;
  } else {
    eventId = stateProps.currentPeriod?.eventId;
  }
  const loadParams = {
    region: ownProps.region,
    season: ownProps.season,
    faction: ownProps.faction,
    bracket: ownProps.bracket,
    eventId,
    page: safeParseInt(ownProps.page, 0),
    pageSize: safeParseInt(ownProps.pageSize, 0) || undefined
  };

  const dataChanged =
    stateProps.request.region !== loadParams.region ||
    stateProps.request.season !== loadParams.season ||
    stateProps.request.faction !== loadParams.faction ||
    stateProps.request.bracket !== loadParams.bracket ||
    stateProps.request.eventId !== loadParams.eventId ||
    stateProps.request.page !== loadParams.page;
  if (dataChanged) {
    if (!stateProps.isRequested) {
      dispatchProps.setViewTeamLeaderboardRequested(ownProps.instanceId || 'default', loadParams);
    }
  } else if (stateProps.isErrored) {
    // show error
  } else if (stateProps.isSucceeded) {
    // nop
  }

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps
  };
}

const baseConnector = connect<TPropsFromState, TActions, TKeystoneTeamRankingsProps>(
  mapStateToProps,
  actions,
  mergeProps
);

export function withTeamRankings(WrappedComponent: any) {
  const Component = baseConnector(WrappedComponent);
  return Component;
}
